import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { LoginWithFacebookModalActions } from './login.with.facebook.modal.actions';

@Component({
    selector: 'ig-login-with-facebook',
    templateUrl: './login.with.facebook.modal.html',
    styleUrls: ['./login.with.facebook.modal.scss']
})
export class LoginWithFacebookModal {
    constructor(private dialogRef: MatDialogRef<LoginWithFacebookModal>,
                public actions: LoginWithFacebookModalActions) {
    }

    public login() {
        this.actions.login();
        this.dialogRef.close();
    }

    public close() {
        this.dialogRef.close();
    }
}


// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/visitor/event.details/login.with.facebook.modal/login.with.facebook.modal.ts